import Tag from './Tag'


function Tags({ tagIds }) {
    const tagComponents = tagIds.map(tagId => {
        return <Tag key={tagId} tagId={tagId} />
    })

    return <>
        <div style={{ flexDirection: "row", margin: "0" }}>
            {tagComponents}
        </div>
    </>
}


export default Tags
